<template>
  <el-dialog title="设置Key"
             :visible.sync="paramShow.editKeyVisible"
             :close-on-click-modal="false"
             width="50%">
    <el-form :model="editKeyForm"
             :rules="addKeyFormRules"
             ref="editKeyFormRef"
             label-width="145px"
             @submit.native.prevent>
      <el-form-item label="Key名称"
                    prop="keyName">
        <el-input v-model="editKeyForm.keyName"
                  placeholder="支持字母、数字、下划线，起名时尽量清晰简洁的表示业务身份"></el-input>
      </el-form-item>
      <el-form-item v-if="editKeyForm.platform === 1">
        <span slot="label">
          <el-tooltip effect='dark'
                      placement='top'>
            <span slot="content">数字签名开启后，您设置的Key所发起的所有请求都必须以数字签名的方式提交
              <br /> <a src="" class="link">查看数字签名说明与添加方式</a>
            </span>
            <i class="el-icon-question">数字签名</i>
          </el-tooltip>
        </span>
        <el-switch v-model="openSign"></el-switch>
      </el-form-item>
      <el-form-item label="SK"
                    v-if="editKeyForm.platform === 1 && editKeyItem.sk && openSign">
        {{editKeyItem.sk}}
      </el-form-item>
      <el-form-item label="服务平台"
                    prop="platform">
        <el-radio-group v-model="editKeyForm.platform" disabled>
          <el-radio v-for="item in platformList" :key="item.code" :label="item.code">{{ item.name }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- <el-form-item label="Key名称"
                    prop="keyName">
        <el-input v-model="editKeyForm.keyName"
                  placeholder="支持字母、数字、下划线，起名时尽量清晰简洁的表示业务身份"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="IP白名单"
                    prop="whiteList">
        <el-input v-model="editKeyForm.whiteList"
                  placeholder="非必填，留空表示无IP 限制，添加IP 白名单后，只有白名单中的IP 可访问服务，多个IP 请分多行展示，最多可添加100 个IP"
                  type="textarea"></el-input>
      </el-form-item> -->
      <el-form-item v-if="[1, 3].includes(editKeyForm.platform)" :label="labelMap[editKeyForm.platform].label"
                    prop="whiteList">
        <el-input v-model="editKeyForm.whiteList"
                  :placeholder="labelMap[editKeyForm.platform].placeholder"
                  type="textarea"></el-input>
      </el-form-item>
      <div v-if="editKeyForm.platform === 4">
        <el-row
          v-for="(item, index) in editKeyForm.authInfo.androidAuths"
          :key="index"
        >
          <el-col :span="22">
            <el-form-item
              label="发布版安全码SHA1"
              :prop="`authInfo.androidAuths[${index}].sha1`"
              :rules="addKeyFormRules.authInfo.androidAuths.sha1"
            >
              <el-input
                v-model="item.sha1"
                placeholder="请输入发布版安全码SHA1"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="调试安全码SHA1"
              :prop="`authInfo.androidAuths[${index}].debugSha1`"
              :rules="addKeyFormRules.authInfo.androidAuths.debugSha1"
            >
              <el-input
                v-model="item.debugSha1"
                placeholder="请输入调试安全码SHA1"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="PackageName"
              :prop="`authInfo.androidAuths[${index}].packageName`"
              :rules="addKeyFormRules.authInfo.androidAuths.packageName"
            >
              <el-input
                v-model="item.packageName"
                placeholder="请输入包名，如：com.meituan.sdk，每条配置可授权一个包名，最多可有20条配置"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2" style="padding: 38px 0px 0px 5px">
            <el-button
              v-show="deleteShow"
              type="danger"
              size="mini"
              @click="deleteAndroid(index)"
              >删除</el-button
            >
          </el-col>
        </el-row>
        <el-form-item size="small">
          <el-button type="primary" @click="addSetting">新增一条配置</el-button>
          <el-button type="danger" @click="deleteShow = !deleteShow"
            >删除配置</el-button
          >
        </el-form-item>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="paramShow.editKeyVisible = false">取 消</el-button>
      <el-button type="primary"
                 @click="editKeyInfo">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import http from '@/http/index.js'

export default {
  props: ['paramShow', 'editKeyItem'],
  data() {
    const checkKeyName = (rule, value, cb) => {
      // 字母数组下划线的组合
      const regEmail = /^[0-9a-zA-Z_]{1,}$/;

      if (regEmail.test(value)) {
        // 合法的Key名
        return cb();
      }
      cb(new Error('Key 名称不符合规范，支持字母、数字、下划线，请检查'));
    };
    const checkWhiteList = (rule, value, cb) => {
      if (value === null || value === '') {
        return cb();
      }
      if (this.editKeyForm.platform === 1) {
      // IP校验
        const reg =
        /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
        const valdata = value.split('\n');
        for (let i = 0; i < valdata.length; i++) {
          if (valdata[i].includes('-')) {
            valdata[i].split('-').forEach(item => {
              if (reg.test(item) === false) {
                cb(new Error('IP 规则不符合规范，请检查'));
                return false;
              }
            })
          } else if (reg.test(valdata[i]) === false) {
            cb(new Error('IP 规则不符合规范，请检查'));
            return false;
          }
        }
        return cb();
      } else if (this.editKeyForm.platform === 3) {
        const reg = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/
        const valdata = value.split('\n');
        if (valdata.length > 100) {
          cb(new Error('域名数量不能超过100条'));
          return false;
        }
        for (let i = 0; i < valdata.length; i++) {
          if (reg.test(valdata[i]) === false) {
            cb(new Error('域名规则不符合规范，请检查'));
            return false;
          }
        }
        return cb();
      }
    };
    const checkSha1 = (rule, value, cb) => {
      if (!value) {
        return cb();
      }
      if (/^([0-9A-F]{2})([:][0-9A-F]{2}){19}$/.test(value)) {
        return cb();
      }
      cb(new Error('不符合规范，请检查'));
    };
    const checkPackageName = (rule, value, cb) => {
      if (
        /^([a-zA-Z_][a-zA-Z0-9_]*)+([.][a-zA-Z_][a-zA-Z0-9_]*)+$/.test(value)
      ) {
        return cb();
      }
      cb(new Error('不符合规范，请检查'));
    };
    return {
      deleteShow: false,
      labelMap: {
        1: {
          label: 'IP白名单',
          placeholder:
            '非必填，留空表示无IP 限制，添加IP或IP段（以-隔开） 白名单后，只有白名单中的IP 可访问服务，多个IP（段） 请分多行展示，最多可添加100 个IP（段）' },
        3: {
          label: '域名白名单',
          placeholder:
            `非必填，留空表示无域名限制，添加域名白名单后，只有白名单中的域名可访问服务，多个域名请分多行展示，最多可添加100 个域名，示例: lbs.meituan.com`
        }
      },
      editKeyForm: {
        keyName: null,
        platform: null,
        whiteList: null,
        id: null,
        authInfo: {
          androidAuths: []
        }
      },
      openSign: null,
      platformList: [],
      addKeyFormRules: {
        keyName: [
          { required: true, message: '请输入Key名称', trigger: 'blur' },
          {
            max: 50,
            message: 'Key 名称超长，最长支持50 字符',
            trigger: 'blur'
          },
          { validator: checkKeyName, trigger: 'blur' }
        ],
        platform: [
          { required: true, message: '请勾选服务平台', trigger: 'change' }
        ],
        whiteList: [{ validator: checkWhiteList, trigger: 'blur' }],
        authInfo: {
          androidAuths: {
            sha1: [
              { required: true, message: '请输入sha1值', trigger: 'blur' },
              { validator: checkSha1, trigger: 'blur' }
            ],
            debugSha1: [{ validator: checkSha1, trigger: 'blur' }],
            packageName: [
              {
                required: true,
                message: '请输入packageName值',
                trigger: 'blur'
              },
              { validator: checkPackageName, trigger: 'blur' }
            ]
          }
        }
      }
    };
  },
  methods: {
    addSetting() {
      if (this.editKeyForm.authInfo.androidAuths.length > 20) {
        this.$message({
          message: '最多新增20条配置！',
          type: 'warning'
        });
        return;
      }
      this.editKeyForm.authInfo.androidAuths.push({
        sha1: null,
        debugSha1: null,
        packageName: null
      });
    },
    deleteAndroid(index) {
      if (this.editKeyForm.authInfo.androidAuths.length === 1) {
        this.$message({
          message: '须保留至少一组配置',
          type: 'warning'
        });
      } else {
        this.$confirm('此操作将删除该行配置?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.editKeyForm.authInfo.androidAuths.splice(index, 1);
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
          })
          .catch(() => {});
      }
    },
    editKeyInfo() {
      this.$refs.editKeyFormRef.validate(async (valid) => {
        if (!valid) return;
        if (this.openSign !== !!this.editKeyItem.sk) {
          this.editKeyForm.openSign = this.openSign
        }
        // 发起修改key名称请求
        await http.key.edit(this.editKeyForm);
        // 关闭对话框
        this.paramShow.editKeyVisible = false;
        // 刷新数据列表
        // this.getAppList();
        this.$emit('updateList');
        // 提示修改成功
        this.$message.success('修改Key成功！');
      });
    }
  },
  async created() {
    if (this.editKeyItem && this.editKeyItem.keyName) {
      this.editKeyForm.keyName = this.editKeyItem.keyName;
      this.editKeyForm.platform = this.editKeyItem.platform;
      this.editKeyForm.whiteList = this.editKeyItem.whiteList;
      this.editKeyForm.id = this.editKeyItem.id;
      this.openSign = !!this.editKeyItem.sk
      if (this.editKeyItem.authInfo) {
        this.$set(
          this.editKeyForm,
          'authInfo',
          this.editKeyItem.authInfo
        );
      }
    }
    this.platformList = await http.key.platform()
  }
};
</script>

<style lang="less" scoped>
.link{
  color: #476EEF;
}
.link:hover{
  cursor: pointer;
}
</style>
